import React from "react";
import PropTypes from "prop-types";
import { Form } from "@domestika-dev/prudencio/dist/atoms/Form";

import { ReactSelect } from ".";

export const AreasSelector = ({ errors, ...rest }) => {
  const hasError = errors.length > 0;

  return (
    <>
      <ReactSelect
        size="small"
        required
        isSearchable
        name="areaIds"
        id="areaIds"
        isMulti
        hasError={hasError}
        {...rest}
      />

      {hasError && <Form.Error>{errors.join(", ")}</Form.Error>}
    </>
  );
};

AreasSelector.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  defaultValue: PropTypes.array,
  options: PropTypes.array,
  loading: PropTypes.bool,
  placeholderMessage: PropTypes.string,
  noOptionsMessage: PropTypes.string,
  errors: PropTypes.array,
};

AreasSelector.defaultProps = {
  label: "",
  onChange: () => {},
  defaultValue: [],
  options: [],
  loading: false,
  placeholderMessage: "",
  noOptionsMessage: "",
  errors: [],
};

export default AreasSelector;
